import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'

// Carousel
export default class Carousel {
  constructor() {
    this.init()
  }

  init() {
    if (document.querySelector('.js-people-slider')) {
      this.peopleSlider()
    }
  }

  rem(px) {
    return (px * parseFloat(getComputedStyle(document.documentElement).fontSize)) / 16
  }

  peopleSlider() {
    this.peopleSliderInstance = new Swiper('.js-people-slider', {
      modules: [Autoplay],
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: this.rem(8),
      loop: true,
      threshold: 10,
      speed: 500,
      grabCursor: true,
      allowTouchMove: true,

      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
          centeredSlides: true,
          spaceBetween: this.rem(8),
        },
        1024: {
          slidesPerView: 3,
          centeredSlides: true,
          spaceBetween: this.rem(8),
        },
      },
    })
  }
}
